const customInventorySearchInput = (tripId, isTripSearch) => (store) => {
  if (isTripSearch) {
    return {
      searchInputs: store.tripSearch.searchInputs.customInventory,
      searchObj: store.tripSearch.searchObj.customInventory,
      defaultSearchObj: store.tripSearch.searchObj.customInventory.defaultSearchObj || {},
      responseFilters: store.tripSearch.searchObj.customInventory.responseFilters || {},
    };
  }

  const customInventorySearch = store.customInventory.customInventorySearches[tripId] || {};
  const { sortBy, sortDirection } = store.tripSearch.searchObj.customInventory;
  const { searchObj, searchStatus } = customInventorySearch;
  return {
    searchStatus,
    searchObj: { ...searchObj, sortBy, sortDirection },
    searchInputs: searchObj,
    defaultSearchObj: store.customInventory.customInventorySearches?.[tripId]?.defaultSearchObj,
  };
};
export default customInventorySearchInput;
